// extracted by mini-css-extract-plugin
module.exports = {"footer":"SiteFooter_footer__2sWit","copyright":"SiteFooter_copyright__2KeiM","button":"SiteFooter_button__g-BIN Button_linkButton__1RJqJ Button_button__36aVf"};